"use client";

/**
 * Boundary terakhir: menangkap error yang terjadi di root layout / TenantProvider,
 * yaitu satu-satunya kasus yang TIDAK tertangkap `app/error.tsx`. Sebelum file ini
 * ada, kegagalan di sana menghasilkan layar putih bawaan Next.
 *
 * global-error menggantikan seluruh dokumen, jadi ia HARUS merender <html> dan
 * <body> sendiri — dan tidak boleh bergantung pada TenantProvider (yang mungkin
 * justru penyebab errornya), sehingga warnanya sengaja statis, bukan token brand.
 */
export default function GlobalError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  return (
    <html lang="id">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif",
          background: "#F7F7F8",
          color: "#0D0D0D",
        }}
      >
        <div
          style={{
            maxWidth: 420,
            width: "100%",
            textAlign: "center",
            background: "#fff",
            border: "1px solid rgba(0,0,0,0.07)",
            borderRadius: 16,
            padding: 32,
          }}
        >
          <h1 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 8px" }}>
            Aplikasi gagal dimuat
          </h1>
          <p style={{ fontSize: 14, lineHeight: 1.6, color: "#6B7280", margin: "0 0 24px" }}>
            Terjadi kendala saat menyiapkan halaman. Muat ulang untuk mencoba lagi — datamu tidak
            terpengaruh.
          </p>
          <button
            type="button"
            onClick={unstable_retry}
            style={{
              minHeight: 44,
              padding: "0 20px",
              borderRadius: 12,
              border: "none",
              background: "#0D0D0D",
              color: "#fff",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Muat Ulang
          </button>
          {error.digest && (
            <p style={{ fontSize: 11, color: "#9CA3AF", marginTop: 20 }}>
              Kode error: <code>{error.digest}</code>
            </p>
          )}
        </div>
      </body>
    </html>
  );
}
